
import { supabase } from '@/integrations/supabase/client';

export function useSupabaseClient() {
  return supabase;
}
